import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1 5.928 5.928 1 12 1s11 4.928 11 11-4.928 11-11 11S1 18.072 1 12zm2.2 0c0 4.862 3.938 8.8 8.8 8.8s8.8-3.938 8.8-8.8-3.938-8.8-8.8-8.8A8.798 8.798 0 003.2 12zM17 12a5 5 0 11-10 0 5 5 0 0110 0z"
        fill="#E40046"
      />
    </Svg>
  );
}

export default SvgComponent;
